// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__28S3S","containerItemsCenter":"Skeleton_containerItemsCenter__5SqBH"};